import axios from 'axios'

const state = {
  invoices: [],
  currentInvoice: null,
  loading: false
}

const getters = {
  allInvoices: state => state.invoices,
  currentInvoice: state => state.currentInvoice,
  isLoading: state => state.loading
}

const mutations = {
  SET_INVOICES(state, invoices) {
    state.invoices = invoices
  },
  SET_CURRENT_INVOICE(state, invoice) {
    state.currentInvoice = invoice
  },
  SET_LOADING(state, status) {
    state.loading = status
  }
}

const actions = {
  // Fetch all invoices for the logged-in user
  async fetchInvoices({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/api/invoices')
      commit('SET_INVOICES', response.data)
      commit('SET_LOADING', false)
      return response.data
    } catch (error) {
      commit('SET_LOADING', false)
      throw error
    }
  },
  
  // Fetch a specific invoice by ID
  async fetchInvoice({ commit }, invoiceId) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get(`/api/invoices/${invoiceId}`)
      commit('SET_CURRENT_INVOICE', response.data)
      commit('SET_LOADING', false)
      return response.data
    } catch (error) {
      commit('SET_LOADING', false)
      throw error
    }
  },
  
  // Download invoice as PDF
  async downloadInvoice(_, invoiceId) {
    try {
      const response = await axios.get(`/api/invoices/${invoiceId}/download`, {
        responseType: 'blob'
      })
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `invoice-${invoiceId}.pdf`)
      document.body.appendChild(link)
      link.click()
      
      // Clean up
      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(url)
      
      return response
    } catch (error) {
      // If the server returns a JSON error message instead of a PDF blob
      if (error.response) {
        // Try to read the error as JSON
        try {
          // The error response is probably JSON, not a blob
          const errorData = await new Response(error.response.data).json()
          alert(errorData.message || 'Failed to download invoice')
        } catch (jsonError) {
          // If reading as JSON fails, it's some other error
          alert('Failed to download invoice')
        }
      } else {
        alert('Failed to download invoice')
      }
      throw error
    }
  },
  
  // Mark invoice as paid
  async markAsPaid({ commit, dispatch }, invoiceId) {
    try {
      const response = await axios.post(`/api/invoices/${invoiceId}/pay`)
      // Refresh the current invoice and invoice list
      await dispatch('fetchInvoice', invoiceId)
      await dispatch('fetchInvoices')
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}